<template>
  <div class="help">
    <h3 class="title">帮助中心：</h3>
    <li>如何新增电子健康卡？</li>
    <p>（一）点击【个人中心】，再点击加号</p>
    <img src="@/assets/user-agreement/help-01.png" @click="maskImg('01')" />
    <p>（二）输入个人信息后点击绑定，即可注册绑定成功。</p>
    <img src="@/assets/user-agreement/help-02.png" @click="maskImg('02')" />
    <img src="@/assets/user-agreement/help-03.png" @click="maskImg('03')" />
    <li>如何解绑电子健康卡？</li>
    <p>（一）点击电子健康卡</p>
    <img src="@/assets/user-agreement/help-04.png" @click="maskImg('04')" />
    <p>（二）点击【确定】即可解绑。</p>
    <img src="@/assets/user-agreement/help-05.png" @click="maskImg('05')" />

    <div :class="{'mask':true,'mask_hidden':!show,'mask_show':show}" v-if="show" @click="maskShow">
      <img :src="url" alt />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: "",
      show: false,
    };
  },
  methods: {
    maskImg(name) {
      this.url = require(`@/assets/user-agreement/help-${name}.png`);
      this.show = true;
    },
    maskShow() {
      this.show = false;
    },
  },
};
</script>

<style lang="less" scoped>
.help {
  * {
    margin: 0;
  }
  .title {
    font-size: 35px;
    font-weight: 800;
    padding-bottom: 10px;
  }
  img {
    width: 100%;
    margin-bottom: 10px;
  }
  p,
  li {
    margin-bottom: 10px;
    font-size: 20px;
  }
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-width: 80%;
      max-height: 90%;
    }
  }
  .mask_show {
    z-index: 1000;
  }
  .mask_hidden {
    z-index: -1;
  }
}
</style>